import { jwtAuthAxios } from "../../shared/utils/network-utils";
import {
  CreateCraForecastScenarioRequest,
  CraForecastScenario,
  UpdateCraForecastScenarioRequest,
} from "../models/CraForecastScenario";

export const CraForecastApi = {
  create: async (request: CreateCraForecastScenarioRequest) => {
    return await jwtAuthAxios().post<CraForecastScenario>(
      `/cra-forecast`,
      request,
    );
  },

  update: async (id: string, request: UpdateCraForecastScenarioRequest) => {
    return await jwtAuthAxios().put<CraForecastScenario>(
      `/cra-forecast/${id}`,
      request,
    );
  },

  delete: async (id: string) => {
    return await jwtAuthAxios().delete(`/cra-forecast/${id}`);
  },
};
